"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.token = exports.queryString = exports.queryParam = void 0;
const queryString = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop)
});
/**
 * Nome del parametro in cui viene passato il token di sessione dell'utente.
 * @type {String}
 */

exports.queryString = queryString;
const queryParam = 'zwan_spaces_id';
exports.queryParam = queryParam;
const token = queryString[queryParam];
exports.token = token;